export const analyticsTranslations: Record<string, any> = {
  "pt": {
    "title": "Analítica",
    "subtitle": "Visão visual do teu desempenho financeiro",
    "toggle_full_values": "Mostrar valores completos (0.000)",
    "toggle_thousands": "Reduzir para milhares (0.0k)",
    "total_income_ytd": "Receita Total (Anual)",
    "total_expenses_ytd": "Despesas Totais (Anual)",
    "net_profit_ytd": "Lucro Líquido (Anual)",
    "growth_rate": "Taxa de Crescimento",
    "avg": "Méd",
    "per_month": "/mês",
    "growing": "crescente",
    "stable": "estável",
    "healthy": "saudável",
    "accelerating": "acelerando",
    "vs_previous_period": "vs período anterior",
    "comparison_label": "Comparação",
    "comparison_none": "Comparar com",
    "comparison_yoy": "Ano anterior",
    "vs_previous_year": "vs ano anterior",
    "no_comparable_data": "Sem dados no período comparável",
    "current_period": "Período atual",
    "previous_year": "Ano anterior",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "margem",
    "tab_income_expenses": "Receitas & Despesas",
    "tab_income_expenses_short": "Cronologia",
    "tab_categories": "Categorias",
    "tab_clients": "Clientes",
    "tab_projects": "Projetos",
    "tab_people": "Pessoas",
    "income_vs_expenses_over_time": "Receitas vs Despesas ao Longo do Tempo",
    "best_performing_month": "Melhor Mês de Desempenho",
    "average_net_profit": "Lucro Líquido Médio",
    "trend_growing": "Tendência: Crescente",
    "income": "Receita",
    "expenses": "Despesas",
    "income_previous_year": "Receita (ano anterior)",
    "expenses_previous_year": "Despesas (ano anterior)",
    "revenue": "Faturação",
    "profit": "Lucro",
    "income_by_category": "Receita por Categoria",
    "expenses_by_category": "Despesas por Categoria",
    "of_total_income": "do total de receita",
    "of_total_expenses": "do total de despesas",
    "category_distribution_year": "Distribuição de Categorias (este ano)",
    "account_for": "representam",
    "top_income_categories": "As 2 principais categorias de receita geram 79,2% da faturação total",
    "revenue_by_client": "Faturação por Cliente",
    "expenses_by_person": "Despesas por Pessoa",
    "top_client": "Melhor Cliente",
    "top_person": "Top Pessoa",
    "active_clients": "Clientes Ativos",
    "people_with_costs": "Pessoas com despesas",
    "average_revenue": "Faturação Média",
    "people_contributing": "Pessoas com despesas no período",
    "unassigned": "Sem pessoa",
    "companies_contributing": "Empresas a contribuir com faturação",
    "of_total_revenue": "da faturação total",
    "profitability_by_project": "Rentabilidade por Projeto",
    "most_profitable_project": "Projeto Mais Rentável",
    "active_projects": "Projetos Ativos",
    "total_revenue": "Faturação Total",
    "average_margin": "Margem Média",
    "currently_in_progress": "Atualmente em progresso",
    "all_projects_ytd": "Todos os projetos (Anual)",
    "average_profitability": "Rentabilidade média",
    "projects_revenue_vs_expenses": "Faturação vs Despesas de Projetos (Mensal)",
    "project_details": "Detalhes do Projeto",
    "client": "Cliente",
    "period": "Período",
    "status_completed": "Concluído",
    "status_active": "Ativo",
    "status_planning": "Planeamento",
    "per_client_ytd": "por cliente (Anual)",
    "empty_state_title": "Ainda não existem dados financeiros",
    "empty_state_description": "Liga uma conta bancária para começar a ver métricas reais, gráficos e insights financeiros.",
    "empty_state_button": "Conectar banco",
    "load_error": "Não foi possível carregar a analítica.",
    "loading_overview": "A carregar analítica...",
    "no_data_range": "Sem transações no período selecionado.",
    "no_data_label": "Sem dados",
    "uncategorized": "Sem categoria",
    "no_categories": "Sem categorias ainda.",
    "no_clients": "Ainda sem faturação por clientes.",
    "no_projects": "Ainda sem projetos.",
    "no_people": "Ainda sem despesas por pessoas.",
    "unknown_person": "Pessoa desconhecida",
    "loading_people": "A carregar pessoas...",
    "people_totals_table_title": "Custos por pessoa",
    "people_totals_table_description": "Total de custos por pessoa no período selecionado.",
    "table_person": "Pessoa",
    "table_total_costs": "Total de custos",
    "loading_projects": "A carregar projetos...",
    "projects_load_error": "Não foi possível carregar os projetos.",
    "not_available": "N/D",
    "status_on_hold": "Em pausa",
    "status_cancelled": "Cancelado"
  },
  "en": {
    "title": "Analytics",
    "subtitle": "Visual insights into your financial performance",
    "toggle_full_values": "Show full values (0.000)",
    "toggle_thousands": "Reduce to thousands (0.0k)",
    "total_income_ytd": "Total Income (YTD)",
    "total_expenses_ytd": "Total Expenses (YTD)",
    "net_profit_ytd": "Net Profit (YTD)",
    "growth_rate": "Growth Rate",
    "avg": "Avg",
    "per_month": "/month",
    "growing": "growing",
    "stable": "stable",
    "healthy": "healthy",
    "accelerating": "accelerating",
    "vs_previous_period": "vs previous period",
    "comparison_label": "Comparison",
    "comparison_none": "Compare with",
    "comparison_yoy": "Previous year",
    "vs_previous_year": "vs previous year",
    "no_comparable_data": "No data for comparable period",
    "current_period": "Current period",
    "previous_year": "Previous year",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "margin",
    "tab_income_expenses": "Income & Expenses",
    "tab_income_expenses_short": "Timeline",
    "tab_categories": "Categories",
    "tab_clients": "Clients",
    "tab_projects": "Projects",
    "tab_people": "People",
    "income_vs_expenses_over_time": "Income vs Expenses Over Time",
    "best_performing_month": "Best Performing Month",
    "average_net_profit": "Average Net Profit",
    "trend_growing": "Trend: Growing",
    "income": "Income",
    "expenses": "Expenses",
    "income_previous_year": "Income (previous year)",
    "expenses_previous_year": "Expenses (previous year)",
    "revenue": "Revenue",
    "profit": "Profit",
    "income_by_category": "Income by Category",
    "expenses_by_category": "Expenses by Category",
    "of_total_income": "of total income",
    "of_total_expenses": "of total expenses",
    "category_distribution_year": "Category Distribution (this year)",
    "account_for": "account for",
    "top_income_categories": "Top 2 income categories generate 79.2% of total revenue",
    "revenue_by_client": "Revenue by Client",
    "expenses_by_person": "Expenses by Person",
    "top_client": "Top Client",
    "top_person": "Top Person",
    "active_clients": "Active Clients",
    "people_with_costs": "People with costs",
    "average_revenue": "Average Revenue",
    "people_contributing": "People with expenses in period",
    "unassigned": "Unassigned",
    "companies_contributing": "Companies contributing revenue",
    "of_total_revenue": "of total revenue",
    "profitability_by_project": "Profitability by Project",
    "most_profitable_project": "Most Profitable Project",
    "active_projects": "Active Projects",
    "total_revenue": "Total Revenue",
    "average_margin": "Average Margin",
    "currently_in_progress": "Currently in progress",
    "all_projects_ytd": "All projects (YTD)",
    "average_profitability": "Average profitability",
    "projects_revenue_vs_expenses": "Projects Revenue vs Expenses (Monthly)",
    "project_details": "Project Details",
    "client": "Client",
    "period": "Period",
    "status_completed": "Completed",
    "status_active": "Active",
    "status_planning": "Planning",
    "per_client_ytd": "per client (YTD)",
    "empty_state_title": "No financial data yet",
    "empty_state_description": "Connect your bank account to start seeing real metrics, charts and financial insights.",
    "empty_state_button": "Connect bank account",
    "load_error": "Failed to load analytics.",
    "loading_overview": "Loading analytics...",
    "no_data_range": "No transactions in the selected period.",
    "no_data_label": "No data",
    "uncategorized": "Uncategorized",
    "no_categories": "No categories yet.",
    "no_clients": "No client revenue yet.",
    "no_projects": "No projects yet.",
    "no_people": "No expenses by people yet.",
    "unknown_person": "Unknown person",
    "loading_people": "Loading people...",
    "people_totals_table_title": "Costs by person",
    "people_totals_table_description": "Total costs per person for the selected period.",
    "table_person": "Person",
    "table_total_costs": "Total costs",
    "loading_projects": "Loading projects...",
    "projects_load_error": "Failed to load projects.",
    "not_available": "N/A",
    "status_on_hold": "On hold",
    "status_cancelled": "Cancelled"
  },
  "es": {
    "title": "Analítica",
    "subtitle": "Información visual sobre tu rendimiento financiero",
    "toggle_full_values": "Mostrar valores completos (0.000)",
    "toggle_thousands": "Reducir a miles (0.0k)",
    "total_income_ytd": "Ingresos Totales (Anual)",
    "total_expenses_ytd": "Gastos Totales (Anual)",
    "net_profit_ytd": "Beneficio Neto (Anual)",
    "growth_rate": "Tasa de Crecimiento",
    "avg": "Prom",
    "per_month": "/mes",
    "growing": "creciendo",
    "stable": "estable",
    "healthy": "saludable",
    "accelerating": "acelerando",
    "vs_previous_period": "vs período anterior",
    "comparison_label": "Comparación",
    "comparison_none": "Comparar con",
    "comparison_yoy": "Año anterior",
    "vs_previous_year": "vs año anterior",
    "no_comparable_data": "Sin datos en el período comparable",
    "current_period": "Período actual",
    "previous_year": "Año anterior",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "margen",
    "tab_income_expenses": "Ingresos y Gastos",
    "tab_income_expenses_short": "Cronología",
    "tab_categories": "Categorías",
    "tab_clients": "Clientes",
    "tab_projects": "Proyectos",
    "tab_people": "Personas",
    "income_vs_expenses_over_time": "Ingresos vs Gastos a lo Largo del Tiempo",
    "best_performing_month": "Mejor Mes de Rendimiento",
    "average_net_profit": "Beneficio Neto Promedio",
    "trend_growing": "Tendencia: Creciendo",
    "income": "Ingresos",
    "expenses": "Gastos",
    "income_previous_year": "Ingresos (año anterior)",
    "expenses_previous_year": "Gastos (año anterior)",
    "revenue": "Facturación",
    "profit": "Beneficio",
    "income_by_category": "Ingresos por Categoría",
    "expenses_by_category": "Gastos por Categoría",
    "of_total_income": "de los ingresos totales",
    "of_total_expenses": "de los gastos totales",
    "category_distribution_year": "Distribución de Categorías (este año)",
    "account_for": "representan",
    "top_income_categories": "Las 2 principales categorías de ingresos generan el 79,2% de la facturación total",
    "revenue_by_client": "Facturación por Cliente",
    "expenses_by_person": "Gastos por persona",
    "top_client": "Mejor Cliente",
    "top_person": "Persona principal",
    "active_clients": "Clientes Activos",
    "people_with_costs": "Personas con gastos",
    "average_revenue": "Facturación Promedio",
    "people_contributing": "Personas con gastos en el período",
    "unassigned": "Sin asignar",
    "companies_contributing": "Empresas contribuyendo a la facturación",
    "of_total_revenue": "de la facturación total",
    "profitability_by_project": "Rentabilidad por Proyecto",
    "most_profitable_project": "Proyecto Más Rentable",
    "active_projects": "Proyectos Activos",
    "total_revenue": "Facturación Total",
    "average_margin": "Margen Promedio",
    "currently_in_progress": "Actualmente en progreso",
    "all_projects_ytd": "Todos los proyectos (Anual)",
    "average_profitability": "Rentabilidad promedio",
    "projects_revenue_vs_expenses": "Facturación vs Gastos de Proyectos (Mensual)",
    "project_details": "Detalles del Proyecto",
    "client": "Cliente",
    "period": "Período",
    "status_completed": "Completado",
    "status_active": "Activo",
    "status_planning": "Planificación",
    "per_client_ytd": "por cliente (Anual)",
    "empty_state_title": "Aún no hay datos financieros",
    "empty_state_description": "Conecta tu cuenta bancaria para empezar a ver métricas reales, gráficos e insights financieros.",
    "empty_state_button": "Conectar banco",
    "load_error": "No se pudo cargar la analítica.",
    "loading_overview": "Cargando analítica...",
    "no_data_range": "No hay transacciones en el período seleccionado.",
    "no_data_label": "Sin datos",
    "uncategorized": "Sin categoría",
    "no_categories": "Aún no hay categorías.",
    "no_clients": "Aún no hay facturación por clientes.",
    "no_projects": "Aún no hay proyectos.",
    "no_people": "Aún no hay gastos por personas.",
    "unknown_person": "Persona desconocida",
    "loading_people": "Cargando personas...",
    "people_totals_table_title": "Costes por persona",
    "people_totals_table_description": "Coste total por persona en el período seleccionado.",
    "table_person": "Persona",
    "table_total_costs": "Coste total",
    "loading_projects": "Cargando proyectos...",
    "projects_load_error": "No se pudieron cargar los proyectos.",
    "not_available": "N/D",
    "status_on_hold": "En pausa",
    "status_cancelled": "Cancelado"
  },
  "et": {
    "title": "Analüütika",
    "subtitle": "Visuaalsed ülevaated sinu finantstulemuste kohta",
    "toggle_full_values": "Näita täisväärtusi (0.000)",
    "toggle_thousands": "Vähenda tuhandeteni (0.0k)",
    "total_income_ytd": "Kogutulu (Aasta)",
    "total_expenses_ytd": "Kogukulud (Aasta)",
    "net_profit_ytd": "Netotulu (Aasta)",
    "growth_rate": "Kasvutempo",
    "avg": "Kesk",
    "per_month": "/kuus",
    "growing": "kasvav",
    "stable": "stabiilne",
    "healthy": "tervislik",
    "accelerating": "kiirenev",
    "vs_previous_period": "vs eelmine periood",
    "comparison_label": "Võrdlus",
    "comparison_none": "Võrdle",
    "comparison_yoy": "Eelmine aasta",
    "vs_previous_year": "vs eelmine aasta",
    "no_comparable_data": "Võrreldava perioodi andmed puuduvad",
    "current_period": "Praegune periood",
    "previous_year": "Eelmine aasta",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "marginaal",
    "tab_income_expenses": "Tulu ja Kulud",
    "tab_income_expenses_short": "Ajatelg",
    "tab_categories": "Kategooriad",
    "tab_clients": "Kliendid",
    "tab_projects": "Projektid",
    "tab_people": "Inimesed",
    "income_vs_expenses_over_time": "Tulu vs Kulud Aja Jooksul",
    "best_performing_month": "Parim Kuu",
    "average_net_profit": "Keskmine Netotulu",
    "trend_growing": "Trend: Kasvav",
    "income": "Tulu",
    "expenses": "Kulud",
    "income_previous_year": "Tulu (eelmine aasta)",
    "expenses_previous_year": "Kulud (eelmine aasta)",
    "revenue": "Käive",
    "profit": "Kasum",
    "income_by_category": "Tulu Kategooriate Kaupa",
    "expenses_by_category": "Kulud Kategooriate Kaupa",
    "of_total_income": "kogutulust",
    "of_total_expenses": "kogukuludest",
    "category_distribution_year": "Kategooriate Jaotus (sel aastal)",
    "account_for": "moodustavad",
    "top_income_categories": "2 parimat tulukategooriat genereerivad 79,2% kogukäibest",
    "revenue_by_client": "Käive Kliendi Kaupa",
    "expenses_by_person": "Kulud inimese kaupa",
    "top_client": "Parim Klient",
    "top_person": "Kõige suurema kuluga inimene",
    "active_clients": "Aktiivsed Kliendid",
    "people_with_costs": "Kuludega inimesed",
    "average_revenue": "Keskmine Käive",
    "people_contributing": "Kuludega inimesed perioodil",
    "unassigned": "Määramata",
    "companies_contributing": "Ettevõtted, kes toetavad käivet",
    "of_total_revenue": "kogukäibest",
    "profitability_by_project": "Kasumlikkus Projekti Kaupa",
    "most_profitable_project": "Kasumlikum Projekt",
    "active_projects": "Aktiivsed Projektid",
    "total_revenue": "Kogukäive",
    "average_margin": "Keskmine Marginaal",
    "currently_in_progress": "Praegu pooleli",
    "all_projects_ytd": "Kõik projektid (Aasta)",
    "average_profitability": "Keskmine kasumlikkus",
    "projects_revenue_vs_expenses": "Projektide Käive vs Kulud (Kuus)",
    "project_details": "Projekti Üksikasjad",
    "client": "Klient",
    "period": "Periood",
    "status_completed": "Lõpetatud",
    "status_active": "Aktiivne",
    "status_planning": "Planeerimine",
    "per_client_ytd": "kliendi kohta (Aasta)",
    "empty_state_title": "Finantsilisi andmeid veel pole",
    "empty_state_description": "Ühendage oma pangakonto, et näha tegelikke näitajaid, diagramme ja finantsilisi teadmisi.",
    "empty_state_button": "Ühenda pangakonto",
    "load_error": "Analüütika laadimine ebaõnnestus.",
    "loading_overview": "Laadin analüütikat...",
    "no_data_range": "Valitud perioodil pole tehinguid.",
    "no_data_label": "Andmed puuduvad",
    "uncategorized": "Kategooriata",
    "no_categories": "Kategooriaid pole.",
    "no_clients": "Klienditulu puudub.",
    "no_projects": "Projekte pole.",
    "no_people": "Kulud inimeste kaupa puuduvad.",
    "unknown_person": "Tundmatu inimene",
    "loading_people": "Laen inimesi...",
    "people_totals_table_title": "Kulud inimese kaupa",
    "people_totals_table_description": "Kogu kulu inimese kohta valitud perioodil.",
    "table_person": "Inimene",
    "table_total_costs": "Kokku kulud",
    "loading_projects": "Laadin projekte...",
    "projects_load_error": "Projektide laadimine ebaõnnestus.",
    "not_available": "Pole saadaval",
    "status_on_hold": "Pausil",
    "status_cancelled": "Tühistatud"
  },
  "de": {
    "title": "Analytik",
    "subtitle": "Visuelle Einblicke in deine finanzielle Leistung",
    "toggle_full_values": "Vollständige Werte anzeigen (0.000)",
    "toggle_thousands": "Auf Tausende reduzieren (0.0k)",
    "total_income_ytd": "Gesamteinkommen (Jahr)",
    "total_expenses_ytd": "Gesamtausgaben (Jahr)",
    "net_profit_ytd": "Nettogewinn (Jahr)",
    "growth_rate": "Wachstumsrate",
    "avg": "Ø",
    "per_month": "/Monat",
    "growing": "wachsend",
    "stable": "stabil",
    "healthy": "gesund",
    "accelerating": "beschleunigend",
    "vs_previous_period": "vs vorheriger Zeitraum",
    "comparison_label": "Vergleich",
    "comparison_none": "Vergleichen mit",
    "comparison_yoy": "Vorjahr",
    "vs_previous_year": "vs Vorjahr",
    "no_comparable_data": "Keine Daten für den Vergleichszeitraum",
    "current_period": "Aktueller Zeitraum",
    "previous_year": "Vorjahr",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "Marge",
    "tab_income_expenses": "Einnahmen & Ausgaben",
    "tab_income_expenses_short": "Zeitachse",
    "tab_categories": "Kategorien",
    "tab_clients": "Kunden",
    "tab_projects": "Projekte",
    "tab_people": "Personen",
    "income_vs_expenses_over_time": "Einnahmen vs Ausgaben im Zeitverlauf",
    "best_performing_month": "Bester Monat",
    "average_net_profit": "Durchschnittlicher Nettogewinn",
    "trend_growing": "Trend: Wachsend",
    "income": "Einkommen",
    "expenses": "Ausgaben",
    "income_previous_year": "Einkommen (Vorjahr)",
    "expenses_previous_year": "Ausgaben (Vorjahr)",
    "revenue": "Umsatz",
    "profit": "Gewinn",
    "income_by_category": "Einkommen nach Kategorie",
    "expenses_by_category": "Ausgaben nach Kategorie",
    "of_total_income": "des Gesamteinkommens",
    "of_total_expenses": "der Gesamtausgaben",
    "category_distribution_year": "Kategorienverteilung (dieses Jahr)",
    "account_for": "machen aus",
    "top_income_categories": "Die 2 wichtigsten Einkommenskategorien generieren 79,2% des Gesamtumsatzes",
    "revenue_by_client": "Umsatz nach Kunde",
    "expenses_by_person": "Ausgaben nach Person",
    "top_client": "Top-Kunde",
    "top_person": "Top-Person",
    "active_clients": "Aktive Kunden",
    "people_with_costs": "Personen mit Kosten",
    "average_revenue": "Durchschnittlicher Umsatz",
    "people_contributing": "Personen mit Ausgaben im Zeitraum",
    "unassigned": "Nicht zugeordnet",
    "companies_contributing": "Unternehmen, die Umsatz beitragen",
    "of_total_revenue": "des Gesamtumsatzes",
    "profitability_by_project": "Rentabilität nach Projekt",
    "most_profitable_project": "Rentabelstes Projekt",
    "active_projects": "Aktive Projekte",
    "total_revenue": "Gesamtumsatz",
    "average_margin": "Durchschnittliche Marge",
    "currently_in_progress": "Derzeit in Bearbeitung",
    "all_projects_ytd": "Alle Projekte (Jahr)",
    "average_profitability": "Durchschnittliche Rentabilität",
    "projects_revenue_vs_expenses": "Projektumsatz vs Ausgaben (Monatlich)",
    "project_details": "Projektdetails",
    "client": "Kunde",
    "period": "Zeitraum",
    "status_completed": "Abgeschlossen",
    "status_active": "Aktiv",
    "status_planning": "Planung",
    "per_client_ytd": "pro Kunde (Jahr)",
    "empty_state_title": "Noch keine Finanzdaten",
    "empty_state_description": "Verbinden Sie Ihr Bankkonto, um echte Metriken, Diagramme und finanzielle Einblicke zu sehen.",
    "empty_state_button": "Bankkonto verbinden",
    "load_error": "Analysen konnten nicht geladen werden.",
    "loading_overview": "Analysen werden geladen...",
    "no_data_range": "Keine Transaktionen im ausgewählten Zeitraum.",
    "no_data_label": "Keine Daten",
    "uncategorized": "Ohne Kategorie",
    "no_categories": "Noch keine Kategorien.",
    "no_clients": "Noch keine Kundenumsätze.",
    "no_projects": "Noch keine Projekte.",
    "no_people": "Noch keine Ausgaben nach Personen.",
    "unknown_person": "Unbekannte Person",
    "loading_people": "Personen werden geladen...",
    "people_totals_table_title": "Kosten nach Person",
    "people_totals_table_description": "Gesamtkosten pro Person im ausgewählten Zeitraum.",
    "table_person": "Person",
    "table_total_costs": "Gesamtkosten",
    "loading_projects": "Projekte werden geladen...",
    "projects_load_error": "Projekte konnten nicht geladen werden.",
    "not_available": "k. A.",
    "status_on_hold": "Pausiert",
    "status_cancelled": "Abgebrochen"
  },
  "fr": {
    "title": "Analytique",
    "subtitle": "Aperçus visuels de votre performance financière",
    "toggle_full_values": "Afficher les valeurs complètes (0.000)",
    "toggle_thousands": "Réduire aux milliers (0.0k)",
    "total_income_ytd": "Revenu Total (Année)",
    "total_expenses_ytd": "Dépenses Totales (Année)",
    "net_profit_ytd": "Bénéfice Net (Année)",
    "growth_rate": "Taux de Croissance",
    "avg": "Moy",
    "per_month": "/mois",
    "growing": "croissant",
    "stable": "stable",
    "healthy": "sain",
    "accelerating": "en accélération",
    "vs_previous_period": "vs période précédente",
    "comparison_label": "Comparaison",
    "comparison_none": "Comparer avec",
    "comparison_yoy": "Année précédente",
    "vs_previous_year": "vs année précédente",
    "no_comparable_data": "Pas de données pour la période comparable",
    "current_period": "Période actuelle",
    "previous_year": "Année précédente",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "marge",
    "tab_income_expenses": "Revenus & Dépenses",
    "tab_income_expenses_short": "Chronologie",
    "tab_categories": "Catégories",
    "tab_clients": "Clients",
    "tab_projects": "Projets",
    "tab_people": "Personnes",
    "income_vs_expenses_over_time": "Revenus vs Dépenses au Fil du Temps",
    "best_performing_month": "Meilleur Mois de Performance",
    "average_net_profit": "Bénéfice Net Moyen",
    "trend_growing": "Tendance: Croissant",
    "income": "Revenu",
    "expenses": "Dépenses",
    "income_previous_year": "Revenus (année précédente)",
    "expenses_previous_year": "Dépenses (année précédente)",
    "revenue": "Chiffre d'Affaires",
    "profit": "Bénéfice",
    "income_by_category": "Revenu par Catégorie",
    "expenses_by_category": "Dépenses par Catégorie",
    "of_total_income": "du revenu total",
    "of_total_expenses": "des dépenses totales",
    "category_distribution_year": "Distribution des Catégories (cette année)",
    "account_for": "représentent",
    "top_income_categories": "Les 2 principales catégories de revenus génèrent 79,2% du chiffre d'affaires total",
    "revenue_by_client": "Chiffre d'Affaires par Client",
    "expenses_by_person": "Dépenses par personne",
    "top_client": "Meilleur Client",
    "top_person": "Personne principale",
    "active_clients": "Clients Actifs",
    "people_with_costs": "Personnes avec dépenses",
    "average_revenue": "Chiffre d'Affaires Moyen",
    "people_contributing": "Personnes avec dépenses sur la période",
    "unassigned": "Non attribué",
    "companies_contributing": "Entreprises contribuant au chiffre d'affaires",
    "of_total_revenue": "du chiffre d'affaires total",
    "profitability_by_project": "Rentabilité par Projet",
    "most_profitable_project": "Projet le Plus Rentable",
    "active_projects": "Projets Actifs",
    "total_revenue": "Chiffre d'Affaires Total",
    "average_margin": "Marge Moyenne",
    "currently_in_progress": "Actuellement en cours",
    "all_projects_ytd": "Tous les projets (Année)",
    "average_profitability": "Rentabilité moyenne",
    "projects_revenue_vs_expenses": "Chiffre d'Affaires vs Dépenses des Projets (Mensuel)",
    "project_details": "Détails du Projet",
    "client": "Client",
    "period": "Période",
    "status_completed": "Terminé",
    "status_active": "Actif",
    "status_planning": "Planification",
    "per_client_ytd": "par client (Année)",
    "empty_state_title": "Pas encore de données financières",
    "empty_state_description": "Connectez votre compte bancaire pour commencer à voir de vraies métriques, graphiques et insights financiers.",
    "empty_state_button": "Connecter le compte bancaire",
    "load_error": "Impossible de charger l'analytique.",
    "loading_overview": "Chargement de l'analytique...",
    "no_data_range": "Aucune transaction sur la période sélectionnée.",
    "no_data_label": "Aucune donnée",
    "uncategorized": "Sans catégorie",
    "no_categories": "Pas encore de catégories.",
    "no_clients": "Pas encore de revenus clients.",
    "no_projects": "Pas encore de projets.",
    "no_people": "Aucune dépense par personne pour l'instant.",
    "unknown_person": "Personne inconnue",
    "loading_people": "Chargement des personnes...",
    "people_totals_table_title": "Coûts par personne",
    "people_totals_table_description": "Coût total par personne sur la période sélectionnée.",
    "table_person": "Personne",
    "table_total_costs": "Coût total",
    "loading_projects": "Chargement des projets...",
    "projects_load_error": "Impossible de charger les projets.",
    "not_available": "N/D",
    "status_on_hold": "En pause",
    "status_cancelled": "Annulé"
  },
  "it": {
    "title": "Analitica",
    "subtitle": "Approfondimenti visivi sulla tua performance finanziaria",
    "toggle_full_values": "Mostra valori completi (0.000)",
    "toggle_thousands": "Riduci a migliaia (0.0k)",
    "total_income_ytd": "Reddito Totale (Anno)",
    "total_expenses_ytd": "Spese Totali (Anno)",
    "net_profit_ytd": "Profitto Netto (Anno)",
    "growth_rate": "Tasso di Crescita",
    "avg": "Media",
    "per_month": "/mese",
    "growing": "in crescita",
    "stable": "stabile",
    "healthy": "sano",
    "accelerating": "in accelerazione",
    "vs_previous_period": "vs periodo precedente",
    "comparison_label": "Confronto",
    "comparison_none": "Confronta con",
    "comparison_yoy": "Anno precedente",
    "vs_previous_year": "vs anno precedente",
    "no_comparable_data": "Nessun dato per il periodo comparabile",
    "current_period": "Periodo attuale",
    "previous_year": "Anno precedente",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "margine",
    "tab_income_expenses": "Entrate e Spese",
    "tab_income_expenses_short": "Cronologia",
    "tab_categories": "Categorie",
    "tab_clients": "Clienti",
    "tab_projects": "Progetti",
    "tab_people": "Persone",
    "income_vs_expenses_over_time": "Entrate vs Spese nel Tempo",
    "best_performing_month": "Mese con Migliori Prestazioni",
    "average_net_profit": "Profitto Netto Medio",
    "trend_growing": "Tendenza: In Crescita",
    "income": "Reddito",
    "expenses": "Spese",
    "income_previous_year": "Entrate (anno precedente)",
    "expenses_previous_year": "Spese (anno precedente)",
    "revenue": "Fatturato",
    "profit": "Profitto",
    "income_by_category": "Reddito per Categoria",
    "expenses_by_category": "Spese per Categoria",
    "of_total_income": "del reddito totale",
    "of_total_expenses": "delle spese totali",
    "category_distribution_year": "Distribuzione delle Categorie (quest'anno)",
    "account_for": "rappresentano",
    "top_income_categories": "Le 2 principali categorie di reddito generano il 79,2% del fatturato totale",
    "revenue_by_client": "Fatturato per Cliente",
    "expenses_by_person": "Spese per persona",
    "top_client": "Miglior Cliente",
    "top_person": "Persona principale",
    "active_clients": "Clienti Attivi",
    "people_with_costs": "Persone con spese",
    "average_revenue": "Fatturato Medio",
    "people_contributing": "Persone con spese nel periodo",
    "unassigned": "Non assegnato",
    "companies_contributing": "Aziende che contribuiscono al fatturato",
    "of_total_revenue": "del fatturato totale",
    "profitability_by_project": "Redditività per Progetto",
    "most_profitable_project": "Progetto Più Redditizio",
    "active_projects": "Progetti Attivi",
    "total_revenue": "Fatturato Totale",
    "average_margin": "Margine Medio",
    "currently_in_progress": "Attualmente in corso",
    "all_projects_ytd": "Tutti i progetti (Anno)",
    "average_profitability": "Redditività media",
    "projects_revenue_vs_expenses": "Fatturato vs Spese dei Progetti (Mensile)",
    "project_details": "Dettagli del Progetto",
    "client": "Cliente",
    "period": "Periodo",
    "status_completed": "Completato",
    "status_active": "Attivo",
    "status_planning": "Pianificazione",
    "per_client_ytd": "per cliente (Anno)",
    "empty_state_title": "Nessun dato finanziario ancora",
    "empty_state_description": "Collega il tuo conto bancario per iniziare a vedere metriche reali, grafici e insights finanziari.",
    "empty_state_button": "Collega conto bancario",
    "load_error": "Impossibile caricare l'analitica.",
    "loading_overview": "Caricamento analitica...",
    "no_data_range": "Nessuna transazione nel periodo selezionato.",
    "no_data_label": "Nessun dato",
    "uncategorized": "Senza categoria",
    "no_categories": "Nessuna categoria.",
    "no_clients": "Nessun ricavo clienti.",
    "no_projects": "Nessun progetto.",
    "no_people": "Nessuna spesa per persona al momento.",
    "unknown_person": "Persona sconosciuta",
    "loading_people": "Caricamento persone...",
    "people_totals_table_title": "Costi per persona",
    "people_totals_table_description": "Costo totale per persona nel periodo selezionato.",
    "table_person": "Persona",
    "table_total_costs": "Costo totale",
    "loading_projects": "Caricamento progetti...",
    "projects_load_error": "Impossibile caricare i progetti.",
    "not_available": "N/D",
    "status_on_hold": "In pausa",
    "status_cancelled": "Annullato"
  },
  "nl": {
    "title": "Analyse",
    "subtitle": "Visuele inzichten in je financiële prestaties",
    "toggle_full_values": "Volledige waarden tonen (0.000)",
    "toggle_thousands": "Reduceren naar duizenden (0.0k)",
    "total_income_ytd": "Totaal Inkomen (Jaar)",
    "total_expenses_ytd": "Totale Uitgaven (Jaar)",
    "net_profit_ytd": "Nettowinst (Jaar)",
    "growth_rate": "Groeipercentage",
    "avg": "Gem",
    "per_month": "/maand",
    "growing": "groeiend",
    "stable": "stabiel",
    "healthy": "gezond",
    "accelerating": "versnellend",
    "vs_previous_period": "vs vorige periode",
    "comparison_label": "Vergelijking",
    "comparison_none": "Vergelijk met",
    "comparison_yoy": "Vorig jaar",
    "vs_previous_year": "vs vorig jaar",
    "no_comparable_data": "Geen data voor de vergelijkbare periode",
    "current_period": "Huidige periode",
    "previous_year": "Vorig jaar",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "marge",
    "tab_income_expenses": "Inkomsten & Uitgaven",
    "tab_income_expenses_short": "Tijdlijn",
    "tab_categories": "Categorieën",
    "tab_clients": "Klanten",
    "tab_projects": "Projecten",
    "tab_people": "Personen",
    "income_vs_expenses_over_time": "Inkomsten vs Uitgaven in de Loop van de Tijd",
    "best_performing_month": "Best Presterende Maand",
    "average_net_profit": "Gemiddelde Nettowinst",
    "trend_growing": "Trend: Groeiend",
    "income": "Inkomen",
    "expenses": "Uitgaven",
    "income_previous_year": "Inkomen (vorig jaar)",
    "expenses_previous_year": "Uitgaven (vorig jaar)",
    "revenue": "Omzet",
    "profit": "Winst",
    "income_by_category": "Inkomen per Categorie",
    "expenses_by_category": "Uitgaven per Categorie",
    "of_total_income": "van totaal inkomen",
    "of_total_expenses": "van totale uitgaven",
    "category_distribution_year": "Categorieverdeling (dit jaar)",
    "account_for": "vertegenwoordigen",
    "top_income_categories": "De top 2 inkomstencategorieën genereren 79,2% van de totale omzet",
    "revenue_by_client": "Omzet per Klant",
    "expenses_by_person": "Uitgaven per persoon",
    "top_client": "Topklant",
    "top_person": "Top persoon",
    "active_clients": "Actieve Klanten",
    "people_with_costs": "Personen met kosten",
    "average_revenue": "Gemiddelde Omzet",
    "people_contributing": "Personen met uitgaven in de periode",
    "unassigned": "Niet toegewezen",
    "companies_contributing": "Bedrijven die bijdragen aan omzet",
    "of_total_revenue": "van totale omzet",
    "profitability_by_project": "Winstgevendheid per Project",
    "most_profitable_project": "Meest Winstgevende Project",
    "active_projects": "Actieve Projecten",
    "total_revenue": "Totale Omzet",
    "average_margin": "Gemiddelde Marge",
    "currently_in_progress": "Momenteel in uitvoering",
    "all_projects_ytd": "Alle projecten (Jaar)",
    "average_profitability": "Gemiddelde winstgevendheid",
    "projects_revenue_vs_expenses": "Projectomzet vs Uitgaven (Maandelijks)",
    "project_details": "Projectdetails",
    "client": "Klant",
    "period": "Periode",
    "status_completed": "Voltooid",
    "status_active": "Actief",
    "status_planning": "Planning",
    "per_client_ytd": "per klant (Jaar)",
    "empty_state_title": "Nog geen financiële gegevens",
    "empty_state_description": "Koppel uw bankrekening om echte statistieken, grafieken en financiële inzichten te zien.",
    "empty_state_button": "Bankrekening koppelen",
    "load_error": "Analytics laden mislukt.",
    "loading_overview": "Analytics laden...",
    "no_data_range": "Geen transacties in de geselecteerde periode.",
    "no_data_label": "Geen gegevens",
    "uncategorized": "Zonder categorie",
    "no_categories": "Nog geen categorieën.",
    "no_clients": "Nog geen klantenomzet.",
    "no_projects": "Nog geen projecten.",
    "no_people": "Nog geen uitgaven per persoon.",
    "unknown_person": "Onbekende persoon",
    "loading_people": "Personen laden...",
    "people_totals_table_title": "Kosten per persoon",
    "people_totals_table_description": "Totale kosten per persoon in de geselecteerde periode.",
    "table_person": "Persoon",
    "table_total_costs": "Totale kosten",
    "loading_projects": "Projecten laden...",
    "projects_load_error": "Projecten laden mislukt.",
    "not_available": "n.v.t.",
    "status_on_hold": "Gepauzeerd",
    "status_cancelled": "Geannuleerd"
  },
  "sv": {
    "title": "Analys",
    "subtitle": "Visuella insikter i din finansiella prestation",
    "toggle_full_values": "Visa fullständiga värden (0.000)",
    "toggle_thousands": "Reducera till tusental (0.0k)",
    "total_income_ytd": "Total Inkomst (År)",
    "total_expenses_ytd": "Totala Utgifter (År)",
    "net_profit_ytd": "Nettovinst (År)",
    "growth_rate": "Tillväxttakt",
    "avg": "Sn",
    "per_month": "/månad",
    "growing": "växande",
    "stable": "stabil",
    "healthy": "hälsosam",
    "accelerating": "accelererande",
    "vs_previous_period": "vs föregående period",
    "comparison_label": "Jämförelse",
    "comparison_none": "Jämför med",
    "comparison_yoy": "Föregående år",
    "vs_previous_year": "vs föregående år",
    "no_comparable_data": "Inga data för jämförbar period",
    "current_period": "Nuvarande period",
    "previous_year": "Föregående år",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "marginal",
    "tab_income_expenses": "Inkomster & Utgifter",
    "tab_income_expenses_short": "Tidslinje",
    "tab_categories": "Kategorier",
    "tab_clients": "Klienter",
    "tab_projects": "Projekt",
    "tab_people": "Personer",
    "income_vs_expenses_over_time": "Inkomster vs Utgifter över Tid",
    "best_performing_month": "Bästa Presterande Månad",
    "average_net_profit": "Genomsnittlig Nettovinst",
    "trend_growing": "Trend: Växande",
    "income": "Inkomst",
    "expenses": "Utgifter",
    "income_previous_year": "Inkomst (föregående år)",
    "expenses_previous_year": "Utgifter (föregående år)",
    "revenue": "Omsättning",
    "profit": "Vinst",
    "income_by_category": "Inkomst per Kategori",
    "expenses_by_category": "Utgifter per Kategori",
    "of_total_income": "av total inkomst",
    "of_total_expenses": "av totala utgifter",
    "category_distribution_year": "Kategorifördelning (i år)",
    "account_for": "utgör",
    "top_income_categories": "De 2 främsta inkomstkategorierna genererar 79,2% av den totala omsättningen",
    "revenue_by_client": "Omsättning per Klient",
    "expenses_by_person": "Utgifter per person",
    "top_client": "Toppklient",
    "top_person": "Toppperson",
    "active_clients": "Aktiva Klienter",
    "people_with_costs": "Personer med kostnader",
    "average_revenue": "Genomsnittlig Omsättning",
    "people_contributing": "Personer med utgifter under perioden",
    "unassigned": "Ej tilldelad",
    "companies_contributing": "Företag som bidrar till omsättning",
    "of_total_revenue": "av total omsättning",
    "profitability_by_project": "Lönsamhet per Projekt",
    "most_profitable_project": "Mest Lönsamma Projektet",
    "active_projects": "Aktiva Projekt",
    "total_revenue": "Total Omsättning",
    "average_margin": "Genomsnittlig Marginal",
    "currently_in_progress": "För närvarande pågående",
    "all_projects_ytd": "Alla projekt (År)",
    "average_profitability": "Genomsnittlig lönsamhet",
    "projects_revenue_vs_expenses": "Projektomsättning vs Utgifter (Månatlig)",
    "project_details": "Projektdetaljer",
    "client": "Klient",
    "period": "Period",
    "status_completed": "Slutförd",
    "status_active": "Aktiv",
    "status_planning": "Planering",
    "per_client_ytd": "per klient (År)",
    "empty_state_title": "Inga finansiella data ännu",
    "empty_state_description": "Anslut ditt bankkonto för att börja se riktiga mätvärden, diagram och finansiella insikter.",
    "empty_state_button": "Anslut bankkonto",
    "load_error": "Det gick inte att ladda analysen.",
    "loading_overview": "Laddar analys...",
    "no_data_range": "Inga transaktioner i vald period.",
    "no_data_label": "Inga data",
    "uncategorized": "Okategoriserad",
    "no_categories": "Inga kategorier ännu.",
    "no_clients": "Ingen kundintäkt ännu.",
    "no_people": "Inga utgifter per person ännu.",
    "no_projects": "Inga projekt ännu.",
    "loading_projects": "Laddar projekt...",
    "projects_load_error": "Det gick inte att ladda projekten.",
    "not_available": "N/A",
    "status_on_hold": "Pausad",
    "status_cancelled": "Avbruten",
    "unknown_person": "Okänd person",
    "loading_people": "Laddar personer...",
    "people_totals_table_title": "Kostnader per person",
    "people_totals_table_description": "Totala kostnader per person under vald period.",
    "table_person": "Person",
    "table_total_costs": "Totala kostnader"
  },
  "da": {
    "title": "Analyse",
    "subtitle": "Visuelle indsigter i din finansielle præstation",
    "toggle_full_values": "Vis fulde værdier (0.000)",
    "toggle_thousands": "Reducer til tusinder (0.0k)",
    "total_income_ytd": "Samlet Indkomst (År)",
    "total_expenses_ytd": "Samlede Udgifter (År)",
    "net_profit_ytd": "Nettofortjeneste (År)",
    "growth_rate": "Vækstrate",
    "avg": "Gns",
    "per_month": "/måned",
    "growing": "voksende",
    "stable": "stabil",
    "healthy": "sund",
    "accelerating": "accelererende",
    "vs_previous_period": "vs forrige periode",
    "comparison_label": "Sammenligning",
    "comparison_none": "Sammenlign med",
    "comparison_yoy": "Forrige år",
    "vs_previous_year": "vs forrige år",
    "no_comparable_data": "Ingen data for sammenlignelig periode",
    "current_period": "Nuværende periode",
    "previous_year": "Forrige år",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "margin",
    "tab_income_expenses": "Indkomst & Udgifter",
    "tab_income_expenses_short": "Tidslinje",
    "tab_categories": "Kategorier",
    "tab_clients": "Klienter",
    "tab_projects": "Projekter",
    "tab_people": "Personer",
    "income_vs_expenses_over_time": "Indkomst vs Udgifter over Tid",
    "best_performing_month": "Bedst Præsterende Måned",
    "average_net_profit": "Gennemsnitlig Nettofortjeneste",
    "trend_growing": "Trend: Voksende",
    "income": "Indkomst",
    "expenses": "Udgifter",
    "income_previous_year": "Indkomst (forrige år)",
    "expenses_previous_year": "Udgifter (forrige år)",
    "revenue": "Omsætning",
    "profit": "Fortjeneste",
    "income_by_category": "Indkomst efter Kategori",
    "expenses_by_category": "Udgifter efter Kategori",
    "of_total_income": "af samlet indkomst",
    "of_total_expenses": "af samlede udgifter",
    "category_distribution_year": "Kategorifordeling (i år)",
    "account_for": "udgør",
    "top_income_categories": "De 2 bedste indkomstkategorier genererer 79,2% af den samlede omsætning",
    "revenue_by_client": "Omsætning efter Klient",
    "expenses_by_person": "Udgifter pr. person",
    "top_client": "Topklient",
    "top_person": "Top person",
    "active_clients": "Aktive Klienter",
    "people_with_costs": "Personer med udgifter",
    "average_revenue": "Gennemsnitlig Omsætning",
    "people_contributing": "Personer med udgifter i perioden",
    "unassigned": "Ikke tildelt",
    "companies_contributing": "Virksomheder der bidrager til omsætning",
    "of_total_revenue": "af samlet omsætning",
    "profitability_by_project": "Rentabilitet efter Projekt",
    "most_profitable_project": "Mest Rentable Projekt",
    "active_projects": "Aktive Projekter",
    "total_revenue": "Samlet Omsætning",
    "average_margin": "Gennemsnitlig Margin",
    "currently_in_progress": "I øjeblikket i gang",
    "all_projects_ytd": "Alle projekter (År)",
    "average_profitability": "Gennemsnitlig rentabilitet",
    "projects_revenue_vs_expenses": "Projektomsætning vs Udgifter (Månedlig)",
    "project_details": "Projektdetaljer",
    "client": "Klient",
    "period": "Periode",
    "status_completed": "Afsluttet",
    "status_active": "Aktiv",
    "status_planning": "Planlægning",
    "per_client_ytd": "per klient (År)",
    "empty_state_title": "Ingen finansielle data endnu",
    "empty_state_description": "Tilslut din bankkonto for at begynde at se rigtige målinger, grafer og finansielle indsigter.",
    "empty_state_button": "Tilslut bankkonto",
    "load_error": "Kunne ikke indlæse analysen.",
    "loading_overview": "Indlæser analyse...",
    "no_data_range": "Ingen transaktioner i den valgte periode.",
    "no_data_label": "Ingen data",
    "uncategorized": "Uden kategori",
    "no_categories": "Ingen kategorier endnu.",
    "no_clients": "Ingen kunderevenue endnu.",
    "no_people": "Ingen udgifter pr. person endnu.",
    "no_projects": "Ingen projekter endnu.",
    "loading_projects": "Indlæser projekter...",
    "projects_load_error": "Kunne ikke indlæse projekter.",
    "not_available": "N/A",
    "status_on_hold": "Sat på pause",
    "status_cancelled": "Annulleret",
    "unknown_person": "Ukendt person",
    "loading_people": "Indlæser personer...",
    "people_totals_table_title": "Omkostninger pr. person",
    "people_totals_table_description": "Samlede omkostninger pr. person i den valgte periode.",
    "table_person": "Person",
    "table_total_costs": "Samlede omkostninger"
  },
  "fi": {
    "title": "Analytiikka",
    "subtitle": "Visuaaliset näkemykset taloudelliseen suoritukseesi",
    "toggle_full_values": "Näytä täydelliset arvot (0.000)",
    "toggle_thousands": "Vähennä tuhansiin (0.0k)",
    "total_income_ytd": "Kokonaistulo (Vuosi)",
    "total_expenses_ytd": "Kokonaiskulut (Vuosi)",
    "net_profit_ytd": "Nettovoitto (Vuosi)",
    "growth_rate": "Kasvuvauhti",
    "avg": "Ka",
    "per_month": "/kuukausi",
    "growing": "kasvava",
    "stable": "vakaa",
    "healthy": "terve",
    "accelerating": "kiihtyvä",
    "vs_previous_period": "vs edellinen jakso",
    "comparison_label": "Vertailu",
    "comparison_none": "Vertaa",
    "comparison_yoy": "Edellinen vuosi",
    "vs_previous_year": "vs edellinen vuosi",
    "no_comparable_data": "Ei tietoja vertailukelpoiselta ajalta",
    "current_period": "Nykyinen ajanjakso",
    "previous_year": "Edellinen vuosi",
    "delta_label": "Δ",
    "delta_percent_label": "Δ%",
    "margin": "marginaali",
    "tab_income_expenses": "Tulot & Kulut",
    "tab_income_expenses_short": "Aikajana",
    "tab_categories": "Kategoriat",
    "tab_clients": "Asiakkaat",
    "tab_projects": "Projektit",
    "tab_people": "Ihmiset",
    "income_vs_expenses_over_time": "Tulot vs Kulut Ajan Kuluessa",
    "best_performing_month": "Parhaiten Suoriutuva Kuukausi",
    "average_net_profit": "Keskimääräinen Nettovoitto",
    "trend_growing": "Trendi: Kasvava",
    "income": "Tulo",
    "expenses": "Kulut",
    "income_previous_year": "Tulot (edellinen vuosi)",
    "expenses_previous_year": "Kulut (edellinen vuosi)",
    "revenue": "Liikevaihto",
    "profit": "Voitto",
    "income_by_category": "Tulo Kategorian Mukaan",
    "expenses_by_category": "Kulut Kategorian Mukaan",
    "of_total_income": "kokonaistulosta",
    "of_total_expenses": "kokonaiskuluista",
    "category_distribution_year": "Kategoriajakauma (tänä vuonna)",
    "account_for": "muodostavat",
    "top_income_categories": "2 parasta tulokategoriaa tuottavat 79,2% kokonaistulosta",
    "revenue_by_client": "Liikevaihto Asiakkaan Mukaan",
    "expenses_by_person": "Kulut henkilöittäin",
    "top_client": "Paras Asiakas",
    "top_person": "Huippuhenkilö",
    "active_clients": "Aktiiviset Asiakkaat",
    "people_with_costs": "Henkilöt joilla on kuluja",
    "average_revenue": "Keskimääräinen Liikevaihto",
    "people_contributing": "Henkilöt joilla on kuluja jaksolla",
    "unassigned": "Kohdistamaton",
    "companies_contributing": "Yritykset jotka tuottavat liikevaihtoa",
    "of_total_revenue": "kokonaisliikevaihdosta",
    "profitability_by_project": "Kannattavuus Projektin Mukaan",
    "most_profitable_project": "Kannattavin Projekti",
    "active_projects": "Aktiiviset Projektit",
    "total_revenue": "Kokonaisliikevaihto",
    "average_margin": "Keskimääräinen Marginaali",
    "currently_in_progress": "Parhaillaan käynnissä",
    "all_projects_ytd": "Kaikki projektit (Vuosi)",
    "average_profitability": "Keskimääräinen kannattavuus",
    "projects_revenue_vs_expenses": "Projektien Liikevaihto vs Kulut (Kuukausittain)",
    "project_details": "Projektin Tiedot",
    "client": "Asiakas",
    "period": "Jakso",
    "status_completed": "Valmis",
    "status_active": "Aktiivinen",
    "status_planning": "Suunnittelu",
    "per_client_ytd": "asiakasta kohti (Vuosi)",
    "empty_state_title": "Ei vielä taloudellisia tietoja",
    "empty_state_description": "Yhdistä pankkitilisi nähdäksesi todellisia mittareita, kaavioita ja taloudellisia näkemyksiä.",
    "empty_state_button": "Yhdistä pankkitili",
    "load_error": "Analytiikan lataus epäonnistui.",
    "loading_overview": "Ladataan analytiikkaa...",
    "no_data_range": "Ei tapahtumia valitulla jaksolla.",
    "no_data_label": "Ei tietoja",
    "uncategorized": "Ilman kategoriaa",
    "no_categories": "Ei vielä kategorioita.",
    "no_clients": "Ei vielä asiakastuloja.",
    "no_people": "Ei vielä kuluja henkilöittäin.",
    "no_projects": "Ei vielä projekteja.",
    "loading_projects": "Ladataan projekteja...",
    "projects_load_error": "Projektien lataus epäonnistui.",
    "not_available": "Ei saatavilla",
    "status_on_hold": "Pysäytetty",
    "status_cancelled": "Peruttu",
    "unknown_person": "Tuntematon henkilö",
    "loading_people": "Ladataan henkilöitä...",
    "people_totals_table_title": "Kulut henkilöittäin",
    "people_totals_table_description": "Kokonaiskulut henkilöä kohden valitulla jaksolla.",
    "table_person": "Henkilö",
    "table_total_costs": "Kokonaiskulut"
  }
};
